import { createContext, useContext } from 'react'

import type { RouterData, Pathname, Params, SearchParamsResult, SetSearchParamsFn, LocationState } from '../types'
import { SearchParamContextValue } from '../types'


export const RouterContext = createContext<RouterData>(null)
export const useRouter = () => useContext(RouterContext)
export const useHistory = () => useContext(RouterContext).history

export const PathnameContext = createContext<Pathname>('')
export const usePathname = () => useContext(PathnameContext)

export const SearchParamsContext = createContext<SearchParamContextValue>([ {}, () => {} ])
export const useSearchParams = <T extends SearchParamsResult = SearchParamsResult>() => useContext(SearchParamsContext) as [ T, SetSearchParamsFn ]

export const SearchContext = createContext<string>(null)
export const useSearch = () => useContext(SearchContext)

export const RouteParamsContext = createContext<Params>({})
export const useParams = () => useContext(RouteParamsContext)

export const LocationStateContext = createContext<LocationState>(null)
export const useLocationState = () => useContext(LocationStateContext)
